
import { TranslationRecord } from '../../types';

export const common: TranslationRecord = {
  // Additional common strings
  bestRateMessage: 'Το best available rate προσφέρεται μόνο για απευθείας κρατήσεις',
  
  // Amenities
  freeWifi: 'Δωρεάν Wi-Fi',
  flatScreenTV: 'Επίπεδη Τηλεόραση',
  hairDryer: 'Στεγνωτήρας Μαλλιών',
  toiletries: 'Είδη Προσωπικής Φροντίδας',
  miniBar: 'Μίνι Μπαρ',
  safeBox: 'Χρηματοκιβώτιο',
  
  // Common Words
  explore: 'Εξερεύνηση',
  more: 'Περισσότερα',
  book: 'Κράτηση',
  view: 'Προβολή',
  read: 'Διαβάστε',
  
  // Months and dates 
  january: 'Ιανουαρίου',
  february: 'Φεβρουαρίου',
  march: 'Μαρτίου',
  april: 'Απριλίου',
  may: 'Μαΐου',
  june: 'Ιουνίου',
  july: 'Ιουλίου',
  august: 'Αυγούστου',
  september: 'Σεπτεμβρίου',
  october: 'Οκτωβρίου',
  november: 'Νοεμβρίου',
  december: 'Δεκεμβρίου',
  
  // Button and action words
  bookNow: 'Κράτηση Τώρα',
  checkAvailability: 'Έλεγχος Διαθεσιμότητας',
  getDirections: 'Οδηγίες',
  contactUs: 'Επικοινωνία',
  learnMore: 'Μάθετε Περισσότερα',
  
  // Missing keys from errors
  exploreMore: 'Εξερευνήστε Περισσότερα',
  guestReviewCount: 'Πάνω από 300 κριτικές επισκεπτών',
  
  // Navigation items that appear as keys
  home: 'Αρχική',
  about: 'Σχετικά',
  suites: 'Σουίτες', 
  location: 'Τοποθεσία',
  reviews: 'Κριτικές',
  contact: 'Επικοινωνία',
  
  // Footer specific
  quickLinks: 'Γρήγοροι Σύνδεσμοι',
  companyInfo: 'Στοιχεία Εταιρείας',
  legalHelp: 'Νομικά & Βοήθεια',
  privacyPolicy: 'Πολιτική Απορρήτου',
  rentalConditions: 'Όροι Ενοικίασης',
  cookiePolicy: 'Πολιτική Cookies',
  faq: 'Συχνές Ερωτήσεις',
  
  // Company details
  companyName: 'Επωνυμία: Χρήστος Αθαν. Πετκάκης & Σια Ε.Ε.',
  vatId: 'ΑΦΜ',
  vatNumber: 'EL092615293',
  companyAddress: 'Ερνέστου Εμπράρ 13, 4ος όροφος, Θεσσαλονίκη 54625',
  gemi: 'ΓΕΜΗ',
  gemiNumber: '038228205000',
};
